<div class="container">
    <div *ngIf="loadingUser">
        <p>Loading...</p>
    </div>

    <div *ngIf="!loadingUser && !user">
        <p>Please sign-in to see your profile information.</p>
        <button class="redirect-button" (click)="login()">Sign in</button>
    </div>

    <div *ngIf="!loadingUser && user">
        <div class="login-message">
            <p>Hi, {{ displayName }}!</p>
            <p>Welcome to Exxon Mobil Lighthouse Forecasting Tool.</p>
        </div>
        <button class="redirect-button" (click)="redirectToMainPage()">
            Get Started
        </button>
    </div>
</div>
